import {
	createOpenRequestDispatcher,
	type OpenRequestedDecision,
	type OpenRequestedEvent,
	type OpenRequestedPayload,
} from "./open-request-dispatcher";

export type OpenRequestBridge = {
	observeFromLoader: (
		payload: OpenRequestedPayload,
		options?: {
			preventHostDefault?: () => void;
		},
	) => OpenRequestedDecision;
	subscribe: (listener: (event: OpenRequestedEvent) => void) => () => void;
};

export const createOpenRequestBridge = (): OpenRequestBridge => {
	const dispatcher = createOpenRequestDispatcher();
	return {
		observeFromLoader: (payload, options) =>
			dispatcher.dispatch(payload, options),
		subscribe: (listener) => dispatcher.subscribe(listener),
	};
};
